import React, { useCallback } from 'react';
import Draggable from 'react-draggable';
import {
  DownloadMessageContainer,
  DownloadMessageTitle,
  CloseIcon,
  DownloadErrorMessageLink,
  RetryButton,
} from 'spw-programming-projects/downloads/styles';
import { Box } from '@mui/material';
import { selectFailedDownloadsTemplates } from 'spw-redux/modules/downloads/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadFailedTemplate } from 'spw-programming-projects/downloads/types';
import {
  downloadTemplate,
  setFailedDownloadsTemplates,
} from 'spw-redux/modules/downloads/actions';
import { PROGRAMMING } from 'spw-constants';

const DownloadIncompleteMessages = () => {
  const dispatch = useDispatch();
  const failedDownloadsTemplates = useSelector(selectFailedDownloadsTemplates);

  const removeMessage = useCallback(
    (id: number) => {
      dispatch(
        setFailedDownloadsTemplates(
          failedDownloadsTemplates
            .slice()
            .filter(
              (failedDownloadTemplate: DownloadFailedTemplate) =>
                failedDownloadTemplate.downloadTemplate.id !== id
            )
        )
      );
    },
    [failedDownloadsTemplates, dispatch]
  );

  const retryDownload = useCallback(
    (failedDownloadTemplate: DownloadFailedTemplate) => {
      dispatch(
        downloadTemplate({
          templateId: failedDownloadTemplate.downloadTemplate.id,
        })
      );
      removeMessage(failedDownloadTemplate.downloadTemplate.id);
    },
    [removeMessage, dispatch]
  );

  return failedDownloadsTemplates?.length ? (
    <>
      {failedDownloadsTemplates.map(
        (failedDownloadTemplate: DownloadFailedTemplate, index: number) => {
          const { id, projectId } = failedDownloadTemplate.downloadTemplate;
          return (
            <Draggable
              bounds="#react-container"
              handle={`#download-template-${id}-error-message`}
              key={`download-template-${id}-error-message`}
            >
              <DownloadMessageContainer
                style={{ top: 10 + 70 * index }}
                id={`download-template-${id}-error-message`}
              >
                <Box display="flex">
                  <Box flexGrow={1} display="flex" alignItems="center">
                    <div>
                      <DownloadMessageTitle>
                        <Box flexGrow={1}>Download Incomplete</Box>
                      </DownloadMessageTitle>
                      {failedDownloadTemplate.isNewTemplate ? (
                        <div style={{ width: 288 }}>
                          The wizard saved the download as a{' '}
                          <DownloadErrorMessageLink
                            onClick={() => removeMessage(id)}
                            to={`/projects/${PROGRAMMING}/${projectId}/downloads/templates/${id}`}
                          >
                            template
                          </DownloadErrorMessageLink>
                          .
                        </div>
                      ) : (
                        <div style={{ width: 288 }}>
                          Please try downloading the{' '}
                          <DownloadErrorMessageLink
                            onClick={() => removeMessage(id)}
                            to={`/projects/${PROGRAMMING}/${projectId}/downloads/templates/${id}`}
                          >
                            template
                          </DownloadErrorMessageLink>{' '}
                          again.
                        </div>
                      )}
                    </div>

                    <RetryButton
                      onClick={() => retryDownload(failedDownloadTemplate)}
                    >
                      <img
                        width={18}
                        height={18}
                        src="/images/download-icons/download-gray.svg"
                        alt="download-icon"
                      />
                      <span className="text">RETRY</span>
                    </RetryButton>
                  </Box>
                  <CloseIcon
                    src="/images/icons/close_small.svg"
                    alt="close-icon"
                    onClick={() => removeMessage(id)}
                  />
                </Box>
              </DownloadMessageContainer>
            </Draggable>
          );
        }
      )}
    </>
  ) : null;
};

export default DownloadIncompleteMessages;
